angular.module("vgresiduos").controller("AreaEditCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/area/${$stateParams.id}`);
		};
	}
]);
